/* Jalopín · comportamiento propio: menú, cesta, galería, barra fija, filtros, «Cargar más». Sin dependencias. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var html = document.documentElement;

  /* ---------- Cabecera: sombra al bajar y altura para la barra fija de colección ---------- */
  var cab = $('.jl-cab');
  function medirCab() {
    if (cab) html.style.setProperty('--jl-cab-h', cab.getBoundingClientRect().height + 'px');
  }
  if (cab) {
    var onScroll = function () { cab.classList.toggle('is-scrolled', window.scrollY > 8); medirCab(); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', medirCab);
    onScroll();
  }

  /* ---------- 27 oct: la cabecera se esconde al bajar y vuelve al subir, en toda la web (interruptor) ---------- */
  (function () {
    var sec = cab && cab.closest('.shopify-section');
    if (!sec || !document.body.classList.contains('jl-p-ocultar')) return;
    var ultimo = window.scrollY, oculta = false;
    function poner(v) {
      if (v === oculta) return;
      oculta = v;
      sec.classList.toggle('jl-cab-oculta', v);
      html.classList.toggle('jl-cab-oculta', v);
    }
    window.addEventListener('scroll', function () {
      var y = window.scrollY, d = y - ultimo;
      if (Math.abs(d) < 6) return;
      poner(d > 0 && y > 160);
      ultimo = y;
    }, { passive: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-jl-menu], [data-jl-favs-abrir], [data-jl-fil-abrir]')) poner(false);
    });
  })();

  /* 30 oct · cuántas tarjetas avanza un carrusel: 2 en el móvil; desde 990 px, las que se ven enteras (una pantalla) */
  function jlPasoCarrusel(fila, hijos) {
    if (!window.matchMedia('(min-width:990px)').matches || !hijos.length) return 2;
    var w = hijos[0].getBoundingClientRect().width, gap = parseFloat(getComputedStyle(fila).columnGap) || 0;
    return Math.max(1, Math.floor((fila.clientWidth + gap + 2) / (w + gap)));
  }

  /* ---------- 28 oct: carruseles con puntos que avanzan de dos en dos (interruptor) ---------- */
  (function () {
    if (!document.body.classList.contains('jl-p-puntos')) return;
    $$('.jl-carrusel, .jl-marcas__fila').forEach(function (fila) {
      var hijos = Array.prototype.slice.call(fila.children);
      if (hijos.length < 3) return;
      var puntos = document.createElement('div');
      puntos.className = 'jl-puntos';
      puntos.setAttribute('aria-hidden', 'true');
      fila.parentNode.insertBefore(puntos, fila.nextSibling);
      var paradas = [];
      function medir() {
        var max = fila.scrollWidth - fila.clientWidth, base = fila.getBoundingClientRect().left - fila.scrollLeft;
        var pad = parseFloat(getComputedStyle(fila).paddingLeft) || 0;
        paradas = [];
        var paso = jlPasoCarrusel(fila, hijos);   // 30 oct: 2 en el móvil; en ordenador, las tarjetas que caben en pantalla
        hijos.forEach(function (h, i) {
          if (i % paso) return;
          var x = Math.min(Math.max(h.getBoundingClientRect().left - base - pad, 0), max);
          if (!paradas.length || x - paradas[paradas.length - 1] > 8) paradas.push(x);
        });
        if (max > 0 && max - paradas[paradas.length - 1] > 8) paradas.push(max);
        puntos.hidden = paradas.length < 2;
        puntos.innerHTML = '';
        paradas.forEach(function (x) {
          var b = document.createElement('span');
          b.addEventListener('click', function () { fila.scrollTo({ left: x, behavior: 'smooth' }); });
          puntos.appendChild(b);
        });
        marcar();
      }
      function marcar() {
        var x = fila.scrollLeft, mejor = 0;
        paradas.forEach(function (p, i) { if (Math.abs(p - x) < Math.abs(paradas[mejor] - x)) mejor = i; });
        Array.prototype.forEach.call(puntos.children, function (s, i) { s.classList.toggle('is-act', i === mejor); });
      }
      fila.addEventListener('scroll', marcar, { passive: true });
      window.addEventListener('resize', medir);
      window.addEventListener('load', medir);
      medir();
    });
  })();

  /* ---------- 28 oct: menú, cesta, favoritos y filtros se cierran con el «atrás» del móvil ----------
     Al abrir uno se apunta un paso en el historial (si ya había otro abierto, se cambia uno por otro, no se apila).
     Al cerrarlo con su botón se deshace ese paso; el «atrás» del móvil lo cierra sin salir de la página. */
  var atrasCierres = {};
  function atrasPoner(nombre) {
    var s = history.state;
    if (s && s.jlPanel === nombre) return;
    if (s && s.jlPanel) history.replaceState({ jlPanel: nombre }, '');
    else history.pushState({ jlPanel: nombre }, '');
  }
  function atrasQuitar(nombre) {
    if (history.state && history.state.jlPanel === nombre) { history.back(); return true; }
    return false;
  }
  window.addEventListener('popstate', function () {
    var activo = history.state && history.state.jlPanel;
    Object.keys(atrasCierres).forEach(function (k) { if (k !== activo) atrasCierres[k](); });
  });
  /* 3 nov · paneles que «atrás» vuelve a abrir al regresar de un enlace suyo: { datos(): lo que hay abierto, abrir(datos) } */
  var atrasVolver = {};

  /* ---------- Menú: cajón desde la izquierda (90 %, 21 oct) con paneles ---------- */
  var menu = $('#jl-menu');
  var velo = $('#jl-menu-velo');
  var ultimoFoco = null, menuT;
  function abrirMenu(panel) {
    if (!menu) return;
    ultimoFoco = document.activeElement;
    verPanel(panel || 'principal');
    clearTimeout(menuT);
    if (cab) menu.style.setProperty('--jl-menu-top', Math.max(0, cab.getBoundingClientRect().bottom) + 'px');
    html.classList.add('jl-menu-abierto', 'jl-menu-x');
    $$('.jl-cab__hamb').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); b.setAttribute('aria-label', 'Cerrar menú'); });
    menu.hidden = false;
    if (velo) velo.hidden = false;
    html.classList.add('jl-noscroll');
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      menu.classList.add('is-abierto'); if (velo) velo.classList.add('is-abierto');
    }); });
    var cerrar = $('[data-jl-cerrar]', menu);
    if (cerrar) cerrar.focus();
    atrasPoner('menu');
  }
  function cerrarMenu() {
    if (!menu || menu.hidden) return;
    if (atrasQuitar('menu')) return;
    cerrarMenuYa();
  }
  atrasCierres.menu = cerrarMenuYa;
  function cerrarMenuYa() {
    if (!menu || menu.hidden) return;
    menu.classList.remove('is-abierto'); if (velo) velo.classList.remove('is-abierto');
    html.classList.remove('jl-menu-x');
    $$('.jl-cab__hamb').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-label', 'Menú'); });
    html.classList.remove('jl-noscroll');
    clearTimeout(menuT);
    menuT = setTimeout(function () { menu.hidden = true; if (velo) velo.hidden = true; html.classList.remove('jl-menu-abierto'); }, 260);
    if (ultimoFoco) ultimoFoco.focus();
  }
  atrasVolver.menu = {
    datos: function () {
      var p = $('.jl-menu__panel:not([hidden])', menu);
      return { panel: p ? p.dataset.panel : 'principal', y: menu.scrollTop,
               acords: $$('[data-jl-acord][aria-expanded="true"]', menu).map(function (b) { return b.getAttribute('aria-controls'); }) };
    },
    abrir: function (d) {
      if (!menu) return;
      if (menu.hidden) abrirMenu(d.panel); else verPanel(d.panel);
      (d.acords || []).forEach(function (id) {
        var b = $('[data-jl-acord][aria-controls="' + id + '"]', menu);
        if (b && b.getAttribute('aria-expanded') !== 'true') b.click();
      });
      menu.scrollTop = d.y || 0;
    }
  };
  function verPanel(nombre) {
    $$('.jl-menu__panel', menu).forEach(function (p) { p.hidden = p.dataset.panel !== nombre; });
    menu.scrollTop = 0;
    var p = $('.jl-menu__panel[data-panel="' + nombre + '"]', menu);
    var foco = p && $('[data-jl-cerrar], .jl-menu__back', p);
    if (foco) foco.focus();
  }
  document.addEventListener('click', function (e) {
    if (!menu || menu.hidden) return;
    var x = e.target.closest('.jl-cab a, .jl-cab button');
    if (x && !x.hasAttribute('data-jl-menu')) cerrarMenu();
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-jl-menu], [data-jl-cerrar], [data-jl-panel], #jl-menu-velo');
    if (!t) return;
    if (t.hasAttribute('data-jl-menu')) {
      e.preventDefault();
      var abierto = menu && !menu.hidden && menu.classList.contains('is-abierto');
      if (abierto && t.classList.contains('jl-cab__hamb')) cerrarMenu();
      else if (abierto) verPanel(t.getAttribute('data-jl-menu'));
      else abrirMenu(t.getAttribute('data-jl-menu'));
    }
    else if (t.hasAttribute('data-jl-cerrar') || t.id === 'jl-menu-velo') { e.preventDefault(); cerrarMenu(); }
    else if (t.hasAttribute('data-jl-panel')) { e.preventDefault(); verPanel(t.getAttribute('data-jl-panel')); }
  });
  /* 3 nov · el logo, estando ya en la portada, sube arriba del todo. Si recargaba la misma página, Horizon
     (scroll-container.js) devolvía la altura guardada en history.state.scrollTop y te dejaba donde estabas. */
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a.jl-logo');
    if (!a || new URL(a.href, location.href).pathname !== location.pathname) return;
    e.preventDefault(); e.stopPropagation();
    function arriba() {
      try {
        var s = history.state;
        if (s && typeof s === 'object' && s.scrollTop) history.replaceState(Object.assign({}, s, { scrollTop: 0 }), '');
      } catch (er) {}
      window.scrollTo({ top: 0, behavior: 'instant' });   // con 'smooth' algo de la página lo cortaba y no se movía
    }
    if (menu && !menu.hidden) { cerrarMenu(); setTimeout(arriba, 150); }   // tras el «atrás» con que se cierra el menú
    else arriba();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (menu && !menu.hidden) cerrarMenu();
    var fil = $('#jl-fil'); if (fil && !fil.hidden) cerrarFiltros();
    if (window.jlVisorCerrar) window.jlVisorCerrar();
  });

  /* ---------- Cookies: reabrir las preferencias del aviso (24 oct: CookieYes; si no está, el de Shopify) ---------- */
  function cookiesReabrir() {
    if (typeof window.revisitCkyConsent === 'function') { window.revisitCkyConsent(); return true; }
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); return true; }
    return false;
  }
  function botonCookies() {
    var ok = typeof window.revisitCkyConsent === 'function' ||
      !!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function');
    $$('[data-jl-cookies]').forEach(function (b) { b.hidden = !ok; });
    return ok;
  }
  if (!botonCookies()) { window.addEventListener('load', function () { setTimeout(botonCookies, 800); }); }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-jl-cookies]')) return;
    e.preventDefault();
    cookiesReabrir();
  });

  /* ---------- Favoritos (14 oct): piden iniciar sesión y se guardan por cliente en este navegador (sin app) ---------- */
  var favPanel = $('#jl-favs');
  var cliente = favPanel ? favPanel.getAttribute('data-cliente') : '';
  var favClave = 'jl-favs-' + (cliente || 'anon');
  function favLeer() { try { return JSON.parse(localStorage.getItem(favClave) || '[]'); } catch (e) { return []; } }
  function favGuardar(l) { try { localStorage.setItem(favClave, JSON.stringify(l)); } catch (e) {} }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var favCompartida = null;   // lista que llega por enlace (?lista=…): se ve sin cuenta y no se guarda
  var ICO_BASURA = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V5h6v2M6.5 7l1 13h9l1-13M10 11v6M14 11v6"/></svg>';
  function favEnlace(l) { return location.origin + '/?lista=' + l.map(function (x) { return x.h; }).join(','); }
  function favPintar() {
    var propia = cliente ? favLeer() : [];
    var l = favCompartida || propia;
    var hs = propia.map(function (x) { return x.h; });
    $$('[data-jl-fav]').forEach(function (b) {
      var on = hs.indexOf(b.getAttribute('data-jl-fav')) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-jl-favs-n]').forEach(function (n) { n.textContent = propia.length; n.hidden = !propia.length; });
    var lista = $('[data-jl-favs-lista]');
    if (!lista) return;
    var tit = $('[data-jl-favs-titulo]'); if (tit) tit.textContent = favCompartida ? 'Lista compartida' : 'Mis favoritos';
    var cta = $('[data-jl-favs-cuenta]'); if (cta) cta.textContent = l.length ? '(' + l.length + ')' : '';
    var intro = $('[data-jl-favs-intro]'); if (intro) intro.hidden = !favCompartida;
    var login = $('[data-jl-favs-login]'); if (login) login.hidden = !!favCompartida;
    var vacio = $('[data-jl-favs-vacio]'); if (vacio) vacio.hidden = l.length > 0;
    var comp = $('[data-jl-favs-comp]');
    if (comp) {
      comp.hidden = !!favCompartida || !l.length;
      if (l.length) {
        var url = favEnlace(l), txt = 'Mi lista de favoritos de Jalopín: ' + url;
        $('[data-jl-favs-wa]', comp).href = 'https://wa.me/?text=' + encodeURIComponent(txt);
        $('[data-jl-favs-mail]', comp).href = 'mailto:?subject=' + encodeURIComponent('Mi lista de favoritos de Jalopín') + '&body=' + encodeURIComponent(txt);
      }
    }
    var pie = $('[data-jl-favs-pie]');
    var conVar = l.filter(function (x) { return x.v; });
    if (pie) pie.hidden = conVar.length < 2;
    /* 3 nov · agotado guardado con «Avísame» (x.a, jl_p_avisame): el dato es del momento de guardarlo */
    var CAMPANA = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9a6 6 0 0 1 12 0c0 6 2.5 7.5 2.5 7.5h-17S6 15 6 9z"/><path d="M10 20a2 2 0 0 0 4 0"/></svg>';
    var carro = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2l2.4 11.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L21 8H6.2"/><circle cx="9.5" cy="20" r="1.3"/><circle cx="17" cy="20" r="1.3"/></svg>';
    lista.innerHTML = l.map(function (x) {
      return '<div class="jl-favs__fila' + (favCompartida ? ' jl-favs__fila--ajena' : '') + '">' +
        '<a class="jl-favs__img" href="' + esc(x.u) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy" width="96" height="96">' : '') + '</a>' +
        '<div class="jl-favs__info"><a href="' + esc(x.u) + '">' + esc(x.t) + '</a><small>' + esc(x.m) + '</small><b>' + esc(x.p) + '</b>' +
          (x.a === '0' ? '<a class="jl-mas-btn jl-mas-btn--avisa" href="' + esc(x.u) + '#jl-avisa" aria-label="Avísame cuando vuelva ' + esc(x.t) + '">' + CAMPANA + '<span class="jl-mas-btn__t" aria-hidden="true">Avísame cuando vuelva</span></a>'
           : x.v ? '<button type="button" class="jl-mas-btn" data-jl-anadir="' + esc(x.v) + '" aria-label="Añadir ' + esc(x.t) + ' a la cesta">' + carro + '<span class="jl-mas-btn__t" aria-hidden="true">Añadir a la cesta</span></button>'
               : '<a class="jl-mas-btn" href="' + esc(x.u) + '" aria-label="Elegir opción de ' + esc(x.t) + '">' + carro + '<span class="jl-mas-btn__t" aria-hidden="true">Elegir opción</span></a>') +
        '</div>' +
        (favCompartida ? '' : '<button type="button" class="jl-favs__quitar" data-jl-fav-quitar="' + esc(x.h) + '" aria-label="Quitar ' + esc(x.t) + ' de favoritos">' + ICO_BASURA + '</button>') +
        '</div>';
    }).join('');
  }
  function favAbrir() {
    if (!favPanel) return;
    if (menu && !menu.hidden) cerrarMenuYa();
    favPintar();
    if (cab) favPanel.style.setProperty('--jl-menu-top', Math.max(0, cab.getBoundingClientRect().bottom) + 'px');   // 23 oct: la cabecera sigue a la vista
    favPanel.hidden = false; html.classList.add('jl-noscroll', 'jl-favs-abierto');
    var c = $('[data-jl-favs-cerrar]', favPanel); if (c) c.focus();
    atrasPoner('favs');
  }
  function favCerrar() {
    if (!favPanel || favPanel.hidden) return;
    if (atrasQuitar('favs')) return;
    favCerrarYa();
  }
  atrasCierres.favs = favCerrarYa;
  atrasVolver.favs = {
    datos: function () { return { y: favPanel.scrollTop }; },
    abrir: function (d) { if (favPanel.hidden) favAbrir(); favPanel.scrollTop = d.y || 0; }
  };
  function favCerrarYa() {
    if (!favPanel || favPanel.hidden) return;
    favPanel.hidden = true; html.classList.remove('jl-noscroll', 'jl-favs-abierto');
    if (favCompartida) {
      favCompartida = null; favPintar();
      try { history.replaceState(null, '', location.pathname); } catch (e) {}
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jl-fav]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      if (!cliente) { favAbrir(); return; }   // sin sesión: el panel pide iniciar sesión
      var l = favLeer(), h = b.getAttribute('data-jl-fav');
      var i = l.findIndex(function (x) { return x.h === h; });
      if (i > -1) { l.splice(i, 1); avisar('Quitado de favoritos'); }
      else {
        l.unshift({ h: h, t: b.getAttribute('data-t'), u: b.getAttribute('data-u'), i: b.getAttribute('data-i'), p: b.getAttribute('data-p'), m: b.getAttribute('data-m'), v: b.getAttribute('data-v'), a: b.getAttribute('data-a') });
        avisar('Guardado en favoritos', 'favs');
      }
      favGuardar(l); favPintar(); return;
    }
    if (e.target.closest('[data-jl-favs-abrir], [data-jl-toast-acc="favs"]')) { e.preventDefault(); if (toast) toast.hidden = true; favAbrir(); return; }
    if (e.target.closest('[data-jl-favs-cerrar]')) { e.preventDefault(); favCerrar(); return; }
    var q = e.target.closest('[data-jl-fav-quitar]');
    if (q) { var hq = q.getAttribute('data-jl-fav-quitar'); favGuardar(favLeer().filter(function (x) { return x.h !== hq; })); favPintar(); return; }
    if (e.target.closest('[data-jl-favs-copiar]')) {
      var enl = favEnlace(favLeer());
      if (navigator.clipboard) navigator.clipboard.writeText(enl).then(function () { avisar('Enlace copiado'); }, function () { avisar(enl); });
      else avisar(enl);
      return;
    }
    var todo = e.target.closest('[data-jl-favs-todo]');
    if (todo) {
      var items = (favCompartida || favLeer()).filter(function (x) { return x.v; }).map(function (x) { return { id: x.v, quantity: 1 }; });
      if (!items.length) return;
      todo.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (c) { contarCesta(cuentaJuguetes(c)); favCerrar(); if (!cajonAbrir(c)) avisar('Añadido a la cesta', 'cesta'); })
        .catch(function (err) { avisar((err && (err.description || err.message)) || 'No se ha podido añadir'); })
        .then(function () { todo.disabled = false; });
    }
  });
  /* Lista compartida: jalopin.es/?lista=handle1,handle2 abre el panel con esos juguetes (23 oct) */
  (function () {
    var m = /[?&]lista=([^&#]+)/.exec(location.search);
    if (!m || !favPanel) return;
    var hs = decodeURIComponent(m[1]).split(',').filter(function (h) { return /^[a-z0-9-]+$/.test(h); }).slice(0, 40);
    if (!hs.length) return;
    Promise.all(hs.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      var l = ps.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
        var v = p.variants.length === 1 && p.variants[0].available ? String(p.variants[0].id) : '';
        return { h: p.handle, t: p.title, u: p.url, i: img, p: eur(p.price), m: p.vendor, v: v };
      });
      if (!l.length) return;
      favCompartida = l; favAbrir();
    });
  })();
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && favPanel && !favPanel.hidden) favCerrar(); });
  favPintar();

  /* ---------- Buscar: el buscador de Horizon si existe; si no, la página de búsqueda ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jl-buscar]');
    if (!b) return;
    var modal = document.getElementById('search-modal');
    if (modal && typeof modal.showDialog === 'function') { e.preventDefault(); modal.showDialog(); }
  });

  /* ---------- Cesta: añadir sin salir de la página ---------- */
  var toast = $('#jl-toast'), toastT;
  // 28 oct: el botón del aviso según el mensaje: «Ver cesta» (abre la cesta lateral), «Ver favoritos» o ninguno
  function avisar(texto, accion) {
    if (!toast) return;
    toast.querySelector('span').textContent = texto;
    var acc = $('[data-jl-toast-acc]', toast);
    if (acc) {
      acc.hidden = !accion;
      acc.textContent = accion === 'favs' ? 'Ver favoritos' : 'Ver cesta';
      acc.setAttribute('data-jl-toast-acc', accion || '');
    }
    toast.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(function () { toast.hidden = true; }, 4000);
  }
  function contarCesta(n) {
    $$('[data-jl-cesta-n]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function cuentaJuguetes(c) {   // 3 nov: los envoltorios de regalo no cuentan como productos
    return c.items.reduce(function (s, x) { return s + (x.properties && x.properties._jl_regalo_de ? 0 : x.quantity); }, 0);
  }
  /* ---------- Cesta lateral (20 oct): se abre al añadir y desde el icono de la cabecera ---------- */
  var cajon = $('#jl-cajon');
  function eur(cts) { return (cts / 100).toFixed(2).replace('.', ',') + ' €'; }
  var ICO_REGALO = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 11.5h15V20a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1z"/><path d="M3.5 7.5h17v4h-17z"/><path d="M12 7.5V21"/><path d="M12 7.5C10.6 4.6 7.2 4 7.2 6.1 7.2 7.5 9.6 7.5 12 7.5zM12 7.5c1.4-2.9 4.8-3.5 4.8-1.4 0 1.4-2.4 1.4-4.8 1.4z"/></svg>';   // = snippets/jalopin-regalo-ico
  var ICO_PAPELERA = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V5h6v2M6.5 7l1 13h9l1-13"/></svg>';
  function envioMsg(total, umbral) {
    var falta = umbral - total;
    return falta > 0 ? 'Te faltan <b>' + eur(falta) + '</b> para el <span class="jl-envmsg__g">🔥 <strong>ENVÍO GRATIS</strong> 🔥</span>'
                     : '🎉 ¡Ya tienes <strong>ENVÍO GRATIS</strong>!';
  }
  function cajonPintar(c, error) {
    var nJug = c.items.reduce(function (s, x) { return s + (esRegalo(x) ? 0 : x.quantity); }, 0);
    $('.jl-cajon__n', cajon).textContent = nJug ? '(' + nJug + ')' : '';
    var umbral = parseInt(cajon.getAttribute('data-umbral'), 10) || 0, env = $('.jl-cajon__envio', cajon);
    if (umbral > 0 && c.item_count) {
      var pct = Math.min(100, Math.round(c.total_price * 100 / umbral)), bar = $('.jl-envbar', env);
      $('.jl-envmsg', env).innerHTML = envioMsg(c.total_price, umbral);
      bar.classList.toggle('is-gratis', c.total_price >= umbral);
      bar.setAttribute('aria-valuenow', pct);
      env.hidden = false;
      requestAnimationFrame(function () { bar.firstElementChild.style.width = pct + '%'; });
    } else { env.hidden = true; }
    var lista = $('.jl-cajon__items', cajon), pie = $('.jl-cajon__pie', cajon), reco = $('.jl-cajon__reco', cajon);
    if (!c.item_count) {
      lista.innerHTML = '<div class="jl-cajon__vacio"><p>Tu cesta está vacía.</p><a class="jl-btn" href="' + esc(cajon.getAttribute('data-juguetes')) + '">Ver juguetes</a></div>';
      pie.hidden = true; reco.innerHTML = ''; return;
    }
    var envDe = regaloPorJuguete(c);
    lista.innerHTML = (error ? '<p class="jl-cajon__error" role="alert">' + esc(error) + '</p>' : '') + c.items.filter(function (x) { return !esRegalo(x); }).map(function (x) {
      var img = x.image ? x.image + (x.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var variante = x.product_has_only_default_variant ? '' : (x.variant_title || '');
      var props = Object.keys(x.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && x.properties[k]; })
        .map(function (k) { return '<span class="jl-cl__var">' + esc(k) + ': ' + esc(x.properties[k]) + '</span>'; }).join('');
      var envs = (envDe[x.variant_id] || []).map(function (w) {
        return '<div class="jl-cl__env"><span class="jl-cl__env-ico" aria-hidden="true">' + ICO_REGALO + '</span>' +
          '<span class="jl-cl__env-t" title="Envuelto para regalo">' + (w.properties.Papel ? 'En ' + esc(w.properties.Papel.toLowerCase()) : 'Para regalo') + (w.quantity > 1 ? ' (' + w.quantity + ')' : '') + '</span>' +
          '<span class="jl-cl__env-p">+' + eur(w.final_line_price) + '</span>' +
          '<button type="button" data-jl-q="0" data-key="' + esc(w.key) + '" aria-label="Quitar el envoltorio de ' + esc(x.product_title) + '">&times;</button></div>';
      }).join('');
      return '<div class="jl-cl">' +
        '<a class="jl-cl__img" href="' + esc(x.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="jl-cl__info"><a class="jl-cl__nom" href="' + esc(x.url) + '">' + esc(x.product_title) + '</a>' +
          (variante ? '<span class="jl-cl__var">' + esc(variante) + '</span>' : '') + props +
          '<div class="jl-cl__pie"><span class="jl-cl__precio">' + eur(x.final_line_price) + '</span>' +
          '<span class="jl-cl__q"><button type="button" data-jl-q="' + (x.quantity - 1) + '" data-key="' + esc(x.key) + '" aria-label="' + (x.quantity > 1 ? 'Quitar uno' : 'Eliminar ' + esc(x.product_title)) + '">' + (x.quantity > 1 ? '−' : ICO_PAPELERA) + '</button>' +
          '<span aria-label="Cantidad">' + x.quantity + '</span>' +
          '<button type="button" data-jl-q="' + (x.quantity + 1) + '" data-key="' + esc(x.key) + '"' + (x.properties && Object.keys(x.properties).length ? '' : ' data-var="' + x.variant_id + '"') + ' aria-label="Añadir uno">+</button></span></div></div>' +
        '<button type="button" class="jl-cl__borrar" data-jl-q="0" data-key="' + esc(x.key) + '" aria-label="Eliminar ' + esc(x.product_title) + '">' + ICO_PAPELERA + '</button>' +
        (envs ? '<div class="jl-cl__envs">' + envs + '</div>' : '') +   // 3 nov: a todo el ancho de la línea, para que se lea el papel
        '</div>';
    }).join('');
    regaloUI(c);
    $('.jl-cajon__total', cajon).textContent = eur(c.total_price);
    $('.jl-cajon__pagar-total', cajon).textContent = '· ' + eur(c.total_price);
    pie.hidden = false;
    cajonReco(reco);
    cajonRapido();
  }
  /* 28 oct · pago en un clic: el bloque se pinta al cargar la página, con la cesta vacía, y Shopify no ofrece carteras.
     Con la cesta ya llena se trae el bloque de /cart, que sí trae Google Pay / Apple Pay, y se sustituye. */
  var rapidoT;
  function cajonRapido() {
    var caja = $('.jl-cajon__rapido', cajon);
    if (!caja) return;
    clearTimeout(rapidoT);
    rapidoT = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevo = doc.querySelector('[data-shopify="dynamic-checkout-cart"]');
          var viejo = $('[data-shopify="dynamic-checkout-cart"]', caja);
          var el = nuevo && nuevo.querySelector('shopify-accelerated-checkout-cart');
          var vacio = !el || (el.getAttribute('wallet-configs') || '[]') === '[]';
          caja.hidden = vacio;
          if (!vacio && viejo) viejo.replaceWith(document.importNode(nuevo, true));
        })
        .catch(function () { caja.hidden = true; });
    }, 300);
  }
  /* «Completa tu pedido»: la sección jalopin-cesta-reco elige con la edad, habilidades y marca de lo que hay en la cesta */
  function cajonReco(reco) {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?section_id=jalopin-cesta-reco')
      .then(function (r) { return r.text(); })
      .then(function (h) {
        var d = new DOMParser().parseFromString(h, 'text/html'), b = d.querySelector('[data-jl-reco-cesta]');
        reco.innerHTML = b && b.querySelector('.jl-rc') ? b.outerHTML : '';
      }).catch(function () { reco.innerHTML = ''; });
  }
  function cajonAbrir(c) {
    if (!cajon) return false;
    cajonPintar(c);
    cajon.hidden = false; html.classList.add('jl-noscroll');
    requestAnimationFrame(function () { requestAnimationFrame(function () { cajon.classList.add('is-abierto'); }); });
    var x = $('.jl-cajon__x', cajon); if (x) x.focus({ preventScroll: true });
    atrasPoner('cesta');
    return true;
  }
  function cajonCerrar() {
    if (!cajon || cajon.hidden) return;
    if (atrasQuitar('cesta')) return;
    cajonCerrarYa();
  }
  atrasCierres.cesta = cajonCerrarYa;
  atrasVolver.cesta = {
    datos: function () { return 1; },
    abrir: function () {
      if (!cajon || !cajon.hidden) return;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
        .then(function (r) { return r.json(); }).then(function (c) { if (c.item_count) cajonAbrir(c); }).catch(function () {});
    }
  };
  function cajonCerrarYa() {
    if (!cajon || cajon.hidden) return;
    cajon.classList.remove('is-abierto'); html.classList.remove('jl-noscroll');
    setTimeout(function () { cajon.hidden = true; }, 300);
  }
  if (cajon) {
    cajon.addEventListener('click', function (e) {
      if (e.target.closest('[data-jl-cajon-cerrar]')) { cajonCerrar(); return; }
      var fl = e.target.closest('[data-jl-rc]');
      if (fl) { var pi = $('.jl-rc__pista', cajon); if (pi) pi.scrollBy({ left: parseInt(fl.getAttribute('data-jl-rc'), 10) * pi.clientWidth * 0.86, behavior: 'smooth' }); return; }
      var q = e.target.closest('[data-jl-q]');
      if (!q) return;
      cajon.classList.add('is-cargando');
      // 3 nov (revisión móvil): el «+» va por add.js, que sí respeta el stock (change.js dejaba pedir más de lo que hay)
      var raiz = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var porAdd = q.hasAttribute('data-var');
      fetch(raiz + (porAdd ? 'cart/add.js' : 'cart/change.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(porAdd ? { items: [{ id: parseInt(q.getAttribute('data-var'), 10), quantity: 1 }] } : { id: q.getAttribute('data-key'), quantity: parseInt(q.getAttribute('data-jl-q'), 10) })
      }).then(function (r) { return porAdd && r.ok ? fetch(raiz + 'cart.js') : r; }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (res.ok) return regaloAjustar(res.j).then(function (c) { contarCesta(cuentaJuguetes(c)); cajonPintar(c); });
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cajonPintar(c, res.j.description || res.j.message || 'No se ha podido cambiar la cantidad'); });
        })
        .catch(function () {})
        .then(function () { cajon.classList.remove('is-cargando'); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cajonCerrar(); });
    document.addEventListener('click', function (e) {
      var ic = e.target.closest('a.jl-cesta, a[data-jl-toast-acc="cesta"]');
      if (!ic || /\/cart\/?$/.test(location.pathname)) return;
      e.preventDefault();
      if (toast) toast.hidden = true;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(cajonAbrir).catch(function () { location.href = ic.href; });
    });
  }
  function anadir(id, cantidad, boton, extras) {
    if (boton) boton.disabled = true;
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: (extras || []).concat([{ id: id, quantity: cantidad || 1 }]) })   // el envoltorio primero: la cesta pone arriba lo último y así sale debajo de su juguete
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (c) {
        contarCesta(cuentaJuguetes(c));
        if (!cajonAbrir(c)) avisar('Añadido a la cesta', 'cesta');
        if (boton) { boton.classList.add('is-ok'); setTimeout(function () { boton.classList.remove('is-ok'); }, 1500); }
        return true;
      })
      .catch(function (err) { avisar((err && (err.description || err.message)) || 'No se ha podido añadir'); return false; })
      .then(function (ok) { if (boton) boton.disabled = false; return ok; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jl-anadir]');
    if (!b) return;
    e.preventDefault();
    anadir(b.getAttribute('data-jl-anadir'), 1, b);
  });
  /* 4 nov · «Añadir a la cesta» del correo «¡Ha vuelto!» (03-scripts/avisos): llega a la ficha con ?jl_cesta=<variante>;
     se añade aquí y se abre la cesta lateral de siempre (antes /cart/add llevaba a la página /cart). Si ya estaba en la
     cesta no se suma otra: solo se abre. El parámetro se quita para que recargar no vuelva a añadir. */
  (function () {
    var u = new URL(location.href), id = u.searchParams.get('jl_cesta');
    if (!id || !/^\d+$/.test(id)) return;
    u.searchParams.delete('jl_cesta'); history.replaceState(history.state, '', u);
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var ya = (c.items || []).some(function (it) { return String(it.variant_id) === id; });
      if (ya) { if (!cajonAbrir(c)) avisar('Ya lo tienes en la cesta', 'cesta'); return; }
      anadir(parseInt(id, 10), 1);
    }).catch(function () { anadir(parseInt(id, 10), 1); });
  })();
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-jl-form-cesta]');
    if (!f) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]').value;
    var q = parseInt((f.querySelector('[name="quantity"]') || {}).value || '1', 10);
    var extras = [], env = f.querySelector('[data-jl-regalo]:checked');
    if (env) {
      var caja = env.closest('[data-jl-regalo-nombre]'), sel = f.querySelector('select[name="id"]');
      var nombre = caja.getAttribute('data-jl-regalo-nombre') + (sel ? ' (' + sel.options[sel.selectedIndex].text.replace(/ · agotado$/, '') + ')' : '');
      var papel = caja.querySelector('[data-jl-papel]:checked');
      extras.push({ id: env.getAttribute('data-jl-regalo'), quantity: q, properties: { 'Para': nombre, 'Papel': papel ? papel.value : 'Papel de regalo', _jl_regalo_de: String(id) } });
    }
    // 3 nov (Cristian): al cambiar de color la casilla sigue marcada (aún decides); una vez añadido se desmarca,
    // para que el siguiente color no entre envuelto sin querer
    anadir(id, q, f.querySelector('.jl-compra__add'), extras).then(function (ok) { if (ok && env) env.checked = false; });
  });

  /* ---------- 3 nov · Regalo (interruptor jl_p_regalo): envoltorio por juguete y mensaje ----------
     El envoltorio es una línea más de la cesta con _jl_regalo_de = variante del juguete. Nunca hay más envoltorios que
     juguetes: si se quita o se baja la cantidad del juguete, regaloAjustar baja la del envoltorio (0 = se quita). */
  function esRegalo(x) { return !!(x.properties && x.properties._jl_regalo_de); }
  function regaloAjustar(c) {
    var hay = {}, cambios = {}, n = 0;
    c.items.forEach(function (x) { if (!esRegalo(x)) hay[x.variant_id] = (hay[x.variant_id] || 0) + x.quantity; });
    c.items.forEach(function (x) {
      if (!esRegalo(x)) return;
      var max = hay[x.properties._jl_regalo_de] || 0;
      if (x.quantity > max) { cambios[x.key] = max; n++; }
      hay[x.properties._jl_regalo_de] = Math.max(0, max - x.quantity);
    });
    if (!n) return Promise.resolve(c);
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: cambios })
    }).then(function (r) { return r.ok ? r.json() : c; })   // 3 nov: un 429 u otro error no cuenta como cesta nueva
      .then(function (j) { return j && j.items ? j : c; }).catch(function () { return c; });
  }
  /* Página /cart: los cambios van por enlaces que recargan; al llegar se ajusta y, si hizo falta, se recarga */
  if (/\/cart\/?$/.test(location.pathname)) {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); })
      .then(function (c) { return regaloAjustar(c).then(function (c2) { if (c2 !== c) recargarUnaVez(); }); }).catch(function () {});
  }
  function recargarUnaVez() {   // como mucho una recarga cada 10 s, para no entrar nunca en bucle
    var k = 'jl-regalo-recarga', ahora = Date.now(), antes = 0;
    try { antes = parseInt(sessionStorage.getItem(k) || '0', 10); sessionStorage.setItem(k, String(ahora)); } catch (e) {}
    if (ahora - antes > 10000) location.reload();
  }
  /* 3 nov (2) · Cesta, como Bizcocho de Yogur: botones «Envolver para regalo» y «Añadir mensaje de regalo».
     Mejora sobre Bizcocho: el panel lista los juguetes de la cesta y se marca cuáles envolver (no hay que contar).
     Sin «Enviar sin precios»: un pedido con envoltorio o mensaje es un regalo y sale siempre sin precios (como Amazon y Zara). */
  function regaloPorJuguete(c) {
    var m = {};
    c.items.forEach(function (x) { if (esRegalo(x)) (m[x.properties._jl_regalo_de] = m[x.properties._jl_regalo_de] || []).push(x); });
    return m;
  }
  function regaloUI(c) {
    var envDe = regaloPorJuguete(c), msg = (c.attributes || {})['Mensaje de regalo'] || '';
    var pend = c.items.filter(function (x) { return !esRegalo(x); }).map(function (x) {
      var hechos = (envDe[x.variant_id] || []).reduce(function (s, w) { return s + w.quantity; }, 0);
      return { x: x, faltan: x.quantity - hechos };
    }).filter(function (o) { return o.faltan > 0; });
    $$('[data-jl-regalo-c]').forEach(function (b) {
      var lista = $('[data-jl-envolver-lista]', b), ok = $('[data-jl-envolver-ok]', b);
      if (lista) {
        lista.innerHTML = pend.length ? pend.map(function (o) {
          var v = o.x.product_has_only_default_variant ? '' : ' (' + o.x.variant_title + ')';
          return '<label class="jl-regalo__chk"><input type="checkbox" checked value="' + o.x.variant_id + '" data-n="' + o.faltan + '" data-nombre="' + esc(o.x.product_title + v) + '"> ' +
            esc(o.x.product_title) + esc(v) + (o.faltan > 1 ? ' <small>(' + o.faltan + ' uds.)</small>' : '') + '</label>';
        }).join('') : '<p class="jl-regalo-c__hecho">Todos tus juguetes ya van envueltos.</p>';
        if (ok) ok.hidden = !pend.length;
        $$('.jl-regalo__papel', b).forEach(function (p) { p.hidden = !pend.length; });
      }
      var m = $('[data-jl-regalo-msg]', b);
      if (m && document.activeElement !== m) m.value = msg;
      var mt = $('[data-jl-mensaje-txt]', b);
      if (mt) mt.textContent = msg ? 'Mensaje añadido ✓' : 'Añadir mensaje de regalo';
    });
  }
  function regaloCesta(c) {   // tras un cambio: en /cart se recarga; en el cajón se repinta
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    contarCesta(cuentaJuguetes(c)); cajonPintar(c);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-jl-regalo-abrir], [data-jl-regalo-cerrar], [data-jl-envolver-ok], [data-jl-mensaje-ok]');
    if (!t) return;
    var b = t.closest('[data-jl-regalo-c]');
    if (!b) return;
    e.preventDefault();
    var raiz = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    if (t.hasAttribute('data-jl-regalo-abrir')) {
      var cual = t.getAttribute('data-jl-regalo-abrir'), p = $('[data-jl-regalo-panel="' + cual + '"]', b), abrir = p.hidden;
      $$('[data-jl-regalo-panel]', b).forEach(function (x) { x.hidden = true; });
      $$('[data-jl-regalo-abrir]', b).forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      p.hidden = !abrir; t.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      if (abrir && cual === 'envolver') fetch(raiz + 'cart.js').then(function (r) { return r.json(); }).then(regaloUI).catch(function () {});
      if (abrir && cual === 'mensaje') { var m = $('[data-jl-regalo-msg]', b); if (m) m.focus(); }
      return;
    }
    if (t.hasAttribute('data-jl-regalo-cerrar')) { $$('[data-jl-regalo-panel]', b).forEach(function (x) { x.hidden = true; }); return; }
    if (t.hasAttribute('data-jl-envolver-ok')) {
      var papel = $('[data-jl-papel]:checked', b), items = [];
      $$('[data-jl-envolver-lista] input:checked', b).forEach(function (i) {
        items.push({ id: b.getAttribute('data-jl-regalo-var'), quantity: parseInt(i.getAttribute('data-n'), 10) || 1,
          properties: { 'Para': i.getAttribute('data-nombre'), 'Papel': papel ? papel.value : 'Papel de regalo', _jl_regalo_de: i.value } });
      });
      if (!items.length) return;
      t.disabled = true;
      fetch(raiz + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { return fetch(raiz + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (c) { $('[data-jl-regalo-panel="envolver"]', b).hidden = true; regaloCesta(c); })
        .catch(function () { avisar('No se ha podido añadir el envoltorio'); })
        .then(function () { t.disabled = false; });
      return;
    }
    if (t.hasAttribute('data-jl-mensaje-ok')) {
      var m = $('[data-jl-regalo-msg]', b);
      fetch(raiz + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Mensaje de regalo': m ? m.value.trim() : '' } }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { $('[data-jl-regalo-panel="mensaje"]', b).hidden = true; regaloUI(c); avisar(m && m.value.trim() ? 'Mensaje guardado' : 'Mensaje quitado'); })
        .catch(function () {});
    }
  });
  if (/\/cart\/?$/.test(location.pathname)) {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(regaloUI).catch(function () {});
  }

  /* ---------- Buscador: últimas búsquedas (en el navegador del cliente) y populares (21 oct) ---------- */
  (function () {
    var CLAVE = 'jl-busquedas';
    function leer() { try { return JSON.parse(localStorage.getItem(CLAVE)) || []; } catch (e) { return []; } }
    function guardar(l) { try { localStorage.setItem(CLAVE, JSON.stringify(l)); } catch (e) {} }
    function anotar(q) {
      q = String(q || '').trim(); if (q.length < 2) return;
      var l = leer().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      l.unshift(q); guardar(l.slice(0, 6));
    }
    var url = new URL(location.href);
    if (/\/search\/?$/.test(location.pathname) && url.searchParams.get('q')) anotar(url.searchParams.get('q'));
    document.addEventListener('submit', function (e) {
      var q = e.target.querySelector && e.target.querySelector('input[name="q"]');
      if (q) anotar(q.value);
    }, true);
    function pintar(s) {
      var l = leer(), caja = $('[data-jl-sug-ultimas]', s), lista = $('[data-jl-sug-lista]', s);
      if (!caja) return;
      lista.innerHTML = l.map(function (q) {
        return '<a href="/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last">' + esc(q) + '</a>';
      }).join('');
      caja.hidden = !l.length;
    }
    $$('[data-jl-sug]').forEach(function (s) {
      var form = s.previousElementSibling, inp = form && $('input[name="q"]', form), t;
      if (!inp) return;
      var siempre = s.hasAttribute('data-jl-sug-siempre');
      var ver = function () { pintar(s); s.hidden = inp.value.trim() !== '' && !siempre; if (!s.querySelector('a')) s.hidden = true; };
      if (siempre) ver();
      inp.addEventListener('focus', function () { clearTimeout(t); ver(); });
      inp.addEventListener('input', ver);
      inp.addEventListener('blur', function () { if (!siempre) t = setTimeout(function () { s.hidden = true; }, 200); });
      s.addEventListener('mousedown', function (e) { e.preventDefault(); });
      s.addEventListener('click', function (e) {
        if (e.target.closest('[data-jl-sug-borrar]')) { guardar([]); ver(); inp.focus(); }
      });
    });
  })();

  /* ---------- Menú: «+» que despliega las subcategorías de una categoría (22 oct) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jl-acord]');
    if (!b) return;
    e.preventDefault();
    var caja = document.getElementById(b.getAttribute('aria-controls'));
    if (!caja) return;
    var abrir = caja.hidden;
    caja.hidden = !abrir;
    b.setAttribute('aria-expanded', abrir ? 'true' : 'false');
    b.querySelector('span').textContent = abrir ? '−' : '+';
    var bloque = b.closest('.jl-menu__acord'); if (bloque) bloque.classList.toggle('is-abierto', abrir);
  });

  /* ---------- Ficha: galería, puntos, vídeo, ampliar ---------- */
  $$('[data-jl-galeria]').forEach(function (g) {
    var pista = $('.jl-gal__pista', g), sl = $$('.jl-gal__sl', g), puntos = $$('.jl-gal__puntos span', g);
    if (!pista || sl.length < 2) return;
    var activo = function () {
      var c = pista.scrollLeft + pista.clientWidth / 2, mejor = 0, d = Infinity;
      sl.forEach(function (s, i) { var m = s.offsetLeft + s.offsetWidth / 2, dd = Math.abs(m - c); if (dd < d) { d = dd; mejor = i; } });
      puntos.forEach(function (p, i) { p.classList.toggle('is-act', i === mejor); });
    };
    pista.addEventListener('scroll', function () { window.requestAnimationFrame(activo); }, { passive: true });
    activo();
  });
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-jl-video]');
    if (v) {
      var s = document.getElementById(v.getAttribute('data-jl-video'));
      if (s) { s.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); var vid = s.querySelector('video'); if (vid) vid.play(); }
      return;
    }
  });

  /* ---------- Ficha: mientras se ve la zona de compra, la burbuja de WhatsApp no la tapa (3 nov, CSS con jl-p-rmwa) ---------- */
  var zonaCompra = $('.jl-fi .jl-compra') || $('#jl-cesta-form .jl-total');
  if (zonaCompra && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { html.classList.toggle('jl-compra-vis', en[0].isIntersecting); }).observe(zonaCompra);
  }

  /* ---------- Ficha: barra fija solo cuando el botón principal sale de pantalla ---------- */
  var principal = $('[data-jl-add-principal]'), barra = $('#jl-barra');
  if (principal && barra && 'IntersectionObserver' in window) {
    var visto = false;
    new IntersectionObserver(function (en) {
      var e0 = en[0];
      if (e0.isIntersecting) visto = true;
      var on = !e0.isIntersecting && e0.boundingClientRect.top < 0;
      barra.classList.toggle('is-on', on);
      barra.setAttribute('aria-hidden', on ? 'false' : 'true');
      barra.inert = !on; // 3 nov: oculta, que su botón tampoco se pueda enfocar
      html.classList.toggle('jl-barra-on', on);
    }).observe(principal);
    $('button', barra).addEventListener('click', function () {
      var f = principal.closest('form');
      if (f && f.requestSubmit) f.requestSubmit(); else if (f) f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---------- Ficha: variantes (precio y disponibilidad) ---------- */
  $$('[data-jl-variantes]').forEach(function (sel) {
    var datos = JSON.parse(document.getElementById(sel.getAttribute('data-jl-variantes')).textContent);
    sel.addEventListener('change', function () {
      var v = datos.filter(function (x) { return String(x.id) === sel.value; })[0];
      if (!v) return;
      $$('[data-jl-precio]').forEach(function (el) {
        var m = /^(.*?)(,\d+)?\s*€$/.exec(v.precio);
        if (el.hasAttribute('data-jl-partes') && m) {
          el.innerHTML = '<span class="jl-fp__e"></span><span class="jl-fp__c"></span>';
          el.firstChild.textContent = m[1];
          el.lastChild.textContent = (m[2] || '') + ' €';
        } else { el.textContent = v.precio; }
      });
      var add = $('.jl-compra__add'), avisa = $('[data-jl-avisa]');
      if (add) { add.disabled = !v.disponible; add.textContent = v.disponible ? 'Añadir a la cesta' : 'Agotado'; }
      if (avisa) {
        avisa.hidden = v.disponible;
        if (add) add.hidden = !v.disponible;
        var rg = $('[data-jl-regalo-caja]'); if (rg) rg.hidden = !v.disponible;
        var tg = $('[data-jl-avisa-tags]', avisa);
        if (tg) tg.value = 'aviso-stock,aviso-' + v.id;
      }
      var st = $('.jl-compra__stock');
      if (st) { st.textContent = v.disponible ? '● En stock' : 'Agotado'; st.classList.toggle('is-no', !v.disponible); }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    });
  });

  /* ---------- Ficha: «Avísame cuando vuelva» (jl_p_avisame) ---------- */
  /* La casilla del boletín suma la etiqueta «newsletter» (la misma del formulario del boletín); sin JS no se suma. */
  /* 4 nov · captcha de Shopify. El formulario de clientes lleva hCaptcha invisible, que Shopify solo prepara al tocar el
     correo (focusin/change) y tarda 1-2 s en cargar; si se pulsa «Avisadme» antes, Shopify para el envío sin decir nada
     (había que pulsar dos veces: «tarda mucho»). Por eso: se prepara al abrir el desplegable (Shopify.captcha.protect) y,
     si al enviar aún no está listo, se espera a que lo esté y se reenvía solo. No se puede enviar por fetch: llega sin la
     ficha del captcha («Missing CAPTCHA token»). Si en 15 s no ha salido, el botón vuelve a «Avisadme» con un aviso. */
  $$('[data-jl-avisa-form]').forEach(function (f) {
    var btn = $('button[type=submit]', f), espera = null, reloj = null;
    function proteger() {
      try { if (!f.dataset.cptcha && window.Shopify && Shopify.captcha && Shopify.captcha.protect) Shopify.captcha.protect(f); } catch (e) {}
    }
    function listo() { return !!(f.dataset.hcaptchaBound || f.dataset.recaptchaBound) || !(window.Shopify && Shopify.captcha); }
    function ocupado(si) {
      if (!btn) return;
      btn.textContent = si ? 'Enviando…' : 'Avisadme';
      btn.style.opacity = si ? '.75' : '';
      if (si) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
    }
    function fallo() {
      clearInterval(espera); espera = null; ocupado(false);
      var p = $('.jl-avisa__err', f);
      if (!p) { p = document.createElement('p'); p.className = 'jl-avisa__err'; p.setAttribute('role', 'alert'); var c = $('.jl-avisa__fila', f); if (c) c.insertAdjacentElement('afterend', p); }
      p.textContent = 'No ha salido. Vuelve a pulsar «Avisadme»; si te pide comprobar que no eres un robot, márcalo.';
    }
    f.addEventListener('submit', function (ev) {
      var tg = $('[data-jl-avisa-tags]', f), bol = $('[data-jl-avisa-bol]', f);
      if (tg && bol && bol.checked && tg.value.indexOf('newsletter') < 0) tg.value += ',newsletter';
      ocupado(true);
      clearTimeout(reloj); reloj = setTimeout(fallo, 15000);
      if (listo()) return;
      ev.preventDefault(); ev.stopImmediatePropagation();
      proteger();
      if (espera) return;
      var n = 0;
      espera = setInterval(function () {
        n++;
        if (listo()) { clearInterval(espera); espera = null; if (f.requestSubmit) f.requestSubmit(btn); else btn.click(); }
        else if (n > 50) fallo();
      }, 200);
    });
    var d = $('details', f);
    if (d) d.addEventListener('toggle', function () { if (d.open) { proteger(); var e = $('input[type=email]', d); if (e && !e.value) e.focus(); } });
    if (d && d.open) proteger();
  });
  if (location.hash === '#jl-avisa') {
    var av = $('[data-jl-avisa]:not([hidden])');
    if (av) { var dd = $('details', av); if (dd) dd.open = true; av.scrollIntoView({ block: 'center' }); }
  }

  /* ---------- 4 nov (Cristian) · Ventana rápida de las tarjetas (jl_p_rapido) ----------
     «Elegir» (producto con varios colores) y «Avísame» (agotado) eran enlaces a la ficha: ahora abren #jl-elige en la
     misma página. Con un color disponible elegido sale «Añadir a la cesta» (anadir → cajón); con uno agotado, el
     formulario de aviso (el mismo de la ficha, con su captcha). El enlace sigue siendo el de la ficha: sin JS, con
     Ctrl/⌘ o si falla la carga, se va a la ficha como antes. Al enviar el aviso la página se recarga: sessionStorage
     guarda qué producto era para reabrir la ventana con «¡Hecho!» o con el error. */
  (function () {
    var vr = $('#jl-elige');
    if (!vr) return;
    var panel = $('.jl-elige__panel', vr), img = $('.jl-elige__img img', vr), tit = $('#jl-elige-tit', vr), imgA = $('.jl-elige__img', vr);
    var precio = $('.jl-elige__precio', vr), estado = $('.jl-elige__estado', vr), ops = $('.jl-elige__ops', vr);
    var opT = $('.jl-elige__op-t', vr), chips = $('.jl-elige__chips', vr), add = $('.jl-elige__add', vr);
    var agot = $('.jl-elige__agot', vr), avisa = $('.jl-elige__avisa', vr), ficha = $('.jl-elige__ficha', vr);
    var form = avisa && $('form', avisa), CLAVE = 'jl-elige', prod = null, vSel = null, foco = null, cerrarT, verOk = false;
    function handleDe(href) { var m = /\/products\/([^\/?#]+)/.exec(new URL(href, location.href).pathname); return m ? decodeURIComponent(m[1]) : null; }
    function abrirYa() {
      clearTimeout(cerrarT);
      vr.hidden = false; html.classList.add('jl-noscroll');
      requestAnimationFrame(function () { requestAnimationFrame(function () { vr.classList.add('is-abierto'); }); });
      atrasPoner('elige');
    }
    function cerrarYa() {
      if (vr.hidden) return;
      vr.classList.remove('is-abierto');
      if (!$('#jl-cajon.is-abierto') && !html.classList.contains('jl-favs-abierto')) html.classList.remove('jl-noscroll');
      cerrarT = setTimeout(function () { vr.hidden = true; }, 250);
      if (foco && foco.focus) try { foco.focus({ preventScroll: true }); } catch (e) {}
    }
    function cerrar() { if (vr.hidden) return; if (atrasQuitar('elige')) return; cerrarYa(); }
    atrasCierres.elige = cerrarYa;
    function pintarVariante(v) {
      vSel = v;
      var foto = (v.featured_image && v.featured_image.src) || prod.featured_image;
      if (foto) { img.src = foto + (foto.indexOf('?') < 0 ? '?' : '&') + 'width=200'; img.hidden = false; } else img.hidden = true;
      precio.textContent = eur(v.price);
      estado.textContent = v.available ? '● En stock' : 'Agotado';
      estado.classList.toggle('is-no', !v.available);
      $$('[data-v]', chips).forEach(function (c) { var si = c.getAttribute('data-v') === String(v.id); c.classList.toggle('is-sel', si); c.setAttribute('aria-checked', si); });
      add.hidden = !v.available;
      if (avisa) {
        avisa.hidden = v.available;
        var tg = $('[data-jl-avisa-tags]', avisa); if (tg) tg.value = 'aviso-stock,aviso-' + v.id;
        var err = $('[data-jl-elige-err]', avisa); if (err && String(v0) !== String(v.id)) err.remove();
        if (!v.available && form) try { if (window.Shopify && Shopify.captcha && Shopify.captcha.protect && !form.dataset.hcaptchaBound) Shopify.captcha.protect(form); } catch (e) {}
      }
      agot.hidden = v.available || !!avisa;
      ficha.href = tit.href = imgA.href = prod.url + '?variant=' + v.id;   // 4 nov (Cristian): foto y nombre también llevan a la ficha
      // tras enviar un aviso: «¡Hecho!» solo en la ventana que vuelve del envío; para otro producto, el formulario otra vez
      if (avisa) { var ok = $('[data-jl-elige-ok]', avisa), cp = $('[data-jl-elige-campos]', avisa); if (ok) ok.hidden = !verOk; if (cp) cp.hidden = verOk && !!ok; }
    }
    function pintar(p, vid) {
      prod = p;
      tit.textContent = p.title;
      chips.innerHTML = '';
      var varios = p.variants.length > 1;
      ops.hidden = !varios;
      if (varios) {
        opT.textContent = p.options.map(function (o) { return o.name; }).join(' / ') + ':';
        p.variants.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'jl-elige__chip' + (v.available ? '' : ' is-agot');
          b.setAttribute('role', 'radio'); b.setAttribute('data-v', v.id);
          b.textContent = v.title + (v.available ? '' : ' · agotado');
          b.addEventListener('click', function () { verOk = false; pintarVariante(v); });
          chips.appendChild(b);
        });
      }
      var v = p.variants.filter(function (x) { return String(x.id) === String(vid); })[0]
        || p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      pintarVariante(v);
    }
    function cargar(handle, vid) {
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (p) { pintar(p, vid); return p; });
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a.jl-mas-btn');
      if (!a || e.ctrlKey || e.metaKey || e.shiftKey || e.button) return;
      var h = handleDe(a.href);
      if (!h) return;
      e.preventDefault();
      foco = a; verOk = false;
      a.setAttribute('aria-busy', 'true');
      cargar(h).then(function () {
        abrirYa();
        var x = $('.jl-elige__x', vr); if (x) x.focus({ preventScroll: true });
        if (!vSel.available) { var em = $('input[type=email]', vr); if (em && !em.value && matchMedia('(hover:hover)').matches) em.focus({ preventScroll: true }); }
      }).catch(function () { location.href = a.href; })
        .then(function () { a.removeAttribute('aria-busy'); });
    });
    vr.addEventListener('click', function (e) { if (e.target.closest('[data-jl-elige-cerrar]')) cerrar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !vr.hidden) cerrar(); });
    add.addEventListener('click', function () {
      if (!vSel) return;
      var id = vSel.id;
      // el cajón ocupa su sitio en el «atrás»: se cierra la ventana sin deshacer el paso y anadir abre la cesta
      cerrarYa();
      anadir(id, 1, add);
    });
    if (form) form.addEventListener('submit', function () {
      try { sessionStorage.setItem(CLAVE, prod ? prod.handle : ''); sessionStorage.setItem(CLAVE + '-v', vSel ? vSel.id : ''); } catch (e) {}
    });
    // vuelta del envío: reabrir con «¡Hecho!» o con el error, solo si lo envió esta ventana
    var h0 = null, v0 = null;
    try { h0 = sessionStorage.getItem(CLAVE); v0 = sessionStorage.getItem(CLAVE + '-v'); sessionStorage.removeItem(CLAVE); sessionStorage.removeItem(CLAVE + '-v'); } catch (e) {}
    if (h0 && avisa && ($('[data-jl-elige-ok]', avisa) || $('[data-jl-elige-err]', avisa))) {
      verOk = !!$('[data-jl-elige-ok]', avisa);
      cargar(h0, v0).then(function () {
        if (verOk) { avisa.hidden = false; add.hidden = true; agot.hidden = true; }
        abrirYa();
      }).catch(function () {});
    }
  })();

  /* ---------- Ficha: «También te puede gustar» (recomendaciones de Shopify) ---------- */
  $$('[data-jl-reco]').forEach(function (box) {
    fetch(box.getAttribute('data-jl-reco')).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html');
      var nuevo = d.querySelector('[data-jl-reco-lista]');
      var fuera = box.getAttribute('data-jl-reco-excluir');
      if (nuevo && fuera) $$('.jl-tj', nuevo).forEach(function (c) { var f = c.querySelector('[data-jl-fav]'); if (f && f.getAttribute('data-jl-fav') === fuera) c.remove(); });
      if (nuevo && $$('.jl-tj', nuevo).length) {
        box.querySelector('[data-jl-reco-lista]').replaceWith(nuevo);
        box.hidden = false;
      }
    }).catch(function () {});
  });

  /* ---------- Colección: texto plegado ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jl-plegar]');
    if (!b) return;
    var s = b.closest('.jl-col__seo');
    var abierto = s.classList.toggle('is-open');
    b.textContent = abierto ? 'Leer menos' : 'Leer más';
    b.setAttribute('aria-expanded', abierto);
  });

  /* ---------- Colección: ordenar ---------- */
  $$('[data-jl-ordenar]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u;
    });
  });
  /* 27 oct: la cinta en movimiento se para y sigue al tocarla (interruptor «Detalles de la auditoría») */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('.jl-cinta');
    if (!c || !document.body.classList.contains('jl-p-detalles')) return;
    c.classList.toggle('is-pausa');
  });
  /* 24 oct: desplegable propio de «Ordenar» */
  function ordCerrar() {
    $$('[data-jl-ord]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); var l = document.getElementById(b.getAttribute('aria-controls')); if (l) l.hidden = true; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jl-ord]');
    if (b) {
      var l = document.getElementById(b.getAttribute('aria-controls')), abrir = l && l.hidden;
      ordCerrar();
      if (abrir) { l.hidden = false; b.setAttribute('aria-expanded', 'true'); var s = $('[aria-selected="true"]', l) || $('button', l); if (s) s.focus(); }
      return;
    }
    var o = e.target.closest('[data-jl-ord-v]');
    if (o) {
      var u = new URL(location.href); u.searchParams.set('sort_by', o.getAttribute('data-jl-ord-v')); u.searchParams.delete('page'); location.href = u;
      return;
    }
    if (!e.target.closest('.jl-ord__lista')) ordCerrar();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') ordCerrar(); });

  /* ---------- Colección: panel de filtros ---------- */
  var fil = $('#jl-fil');
  function abrirFiltros() { if (!fil) return; fil.hidden = false; html.classList.add('jl-noscroll'); var c = $('[data-jl-fil-cerrar]', fil); if (c) c.focus(); atrasPoner('filtros'); }
  function cerrarFiltros() { if (!fil || fil.hidden) return; if (atrasQuitar('filtros')) return; cerrarFiltrosYa(); }
  atrasCierres.filtros = cerrarFiltrosYa;
  function cerrarFiltrosYa() { if (!fil) return; fil.hidden = true; html.classList.remove('jl-noscroll'); var b = $('[data-jl-fil-abrir]'); if (b) b.focus(); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-jl-fil-abrir]')) { e.preventDefault(); abrirFiltros(); }
    else if (e.target.closest('[data-jl-fil-cerrar]')) { e.preventDefault(); cerrarFiltros(); }
    var vm = e.target.closest('[data-jl-vermas]');
    if (vm) { e.preventDefault(); var ops = vm.previousElementSibling; ops.classList.add('is-open'); vm.remove(); }
  });
  if (fil) {
    var form = $('form', fil), ver = $('[data-jl-ver-n]', fil), seccion = fil.getAttribute('data-seccion'), tFil;
    var urlFiltros = function () {
      var fd = new FormData(form), p = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
      return form.getAttribute('action').split('?')[0] + '?' + p.toString(); // 3 nov: en marcas el «q» va en el formulario
    };
    form.addEventListener('change', function () {
      clearTimeout(tFil);
      tFil = setTimeout(function () {
        var u = urlFiltros();
        ver.textContent = 'Calculando…';
        fetch(u + (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + seccion).then(function (r) { return r.text(); }).then(function (t) {
          var d = new DOMParser().parseFromString(t, 'text/html');
          var n = d.querySelector('[data-jl-total]');
          var total = n ? parseInt(n.getAttribute('data-jl-total'), 10) : null;
          ver.textContent = total === null ? 'Ver productos' : (total === 1 ? 'Ver 1 producto' : 'Ver ' + total + ' productos');
          // recuentos por opción
          $$('[data-jl-op]', form).forEach(function (op) {
            var otro = d.querySelector('[data-jl-op="' + CSS.escape(op.getAttribute('data-jl-op')) + '"] em');
            var mio = op.querySelector('em');
            if (otro && mio) mio.textContent = otro.textContent;
          });
        }).catch(function () { ver.textContent = 'Ver productos'; });
      }, 250);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); location.href = urlFiltros(); });
  }

  /* ---------- Colección: «Cargar más» con enlace real a ?page=N y posición al volver ---------- */
  var mas = $('[data-jl-cargar]');
  var rej = $('[data-jl-rejilla]');
  var clave = 'jl-col:' + location.pathname + location.search.replace(/[?&]page=\d+/, '');
  function guardar(pag) { try { sessionStorage.setItem(clave, JSON.stringify({ pag: pag, y: window.scrollY })); } catch (e) {} }
  function leer() { try { return JSON.parse(sessionStorage.getItem(clave) || 'null'); } catch (e) { return null; } }
  function traer(url) {
    return fetch(url).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html');
      var nr = d.querySelector('[data-jl-rejilla]');
      if (nr) Array.prototype.slice.call(nr.children).forEach(function (c) { rej.appendChild(c); });
      var nm = d.querySelector('[data-jl-mas]'), m = $('[data-jl-mas]');
      if (m && nm) m.replaceWith(nm); else if (m) m.remove();
    });
  }
  if (rej) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-jl-cargar]');
      if (!a) return;
      e.preventDefault();
      a.textContent = 'Cargando…';
      var pag = parseInt(a.getAttribute('data-jl-cargar'), 10);
      traer(a.href).then(function () { guardar(pag); });
    });
    window.addEventListener('pagehide', function () { var s = leer(); if (s) guardar(s.pag); });
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var estado = leer();
    if (estado && nav && nav.type === 'back_forward' && estado.pag > 1 && !/[?&]page=/.test(location.search)) {
      var cadena = Promise.resolve();
      var base = new URL(location.href);
      for (var p = 2; p <= estado.pag; p++) {
        (function (pp) { cadena = cadena.then(function () { base.searchParams.set('page', pp); return traer(base.toString()); }); })(p);
      }
      cadena.then(function () { window.scrollTo(0, estado.y); });
    } else if (!nav || nav.type !== 'back_forward') {
      try { sessionStorage.removeItem(clave); } catch (e) {}
    }
  }
  /* ---------- Ficha: «Compra … y recíbelo el …» (hora de Madrid, solo días laborables, festivos del ajuste) ---------- */
  var ent = $('[data-jl-entrega]');
  if (ent && window.Intl) {
    try {
      var dias = parseInt(ent.getAttribute('data-dias'), 10) || 2;
      var corte = parseInt(ent.getAttribute('data-corte'), 10); if (isNaN(corte)) corte = 23;
      var fest = (ent.getAttribute('data-festivos') || '').split(/[\s,;]+/).filter(Boolean);
      var pt = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { pt[x.type] = x.value; });
      var d = new Date(Date.UTC(+pt.year, +pt.month - 1, +pt.day));
      var laborable = function (x) { var w = x.getUTCDay(); return w !== 0 && w !== 6 && fest.indexOf(x.toISOString().slice(0, 10)) < 0; };
      // Recogida = día laborable siguiente al pedido; entrega = laborable siguiente a la recogida (Cristian, 14 oct).
      // Un pedido a partir de la hora límite cuenta como del día siguiente. Lunes → miércoles; viernes, sábado y domingo → martes.
      var entrega = function (desfase) {
        var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + desfase);
        for (var n = 0; n < dias;) { x.setUTCDate(x.getUTCDate() + 1); if (laborable(x)) n++; }
        return x;
      };
      var antes = +pt.hour < corte;
      var f1 = entrega(antes ? 0 : 1);
      var avisoHora = antes && entrega(1).getTime() !== f1.getTime();
      var fecha = new Intl.DateTimeFormat('es-ES', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(f1).replace(',', '');
      ent.innerHTML = (avisoHora ? 'Compra antes de las ' + (corte < 10 ? '0' : '') + corte + ':00 y recíbelo el ' : 'Compra ahora y recíbelo el ') + '<strong>' + fecha + '</strong>';
    } catch (e) {}
  }
  /* ---------- Ficha: «Compártelo» (botón «más»: menú nativo del móvil o copiar el enlace) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-jl-compartir-mas]');
    if (!b) return;
    var caja = b.closest('[data-jl-compartir]');
    var url = caja.getAttribute('data-url'), titulo = caja.getAttribute('data-titulo');
    if (navigator.share) { navigator.share({ title: titulo, url: url }).catch(function () {}); return; }
    var ok = function () { b.classList.add('is-ok'); b.setAttribute('aria-label', 'Enlace copiado'); avisar('Enlace copiado'); setTimeout(function () { b.classList.remove('is-ok'); }, 1800); };
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(ok, function () {}); 
  });
  /* ---------- Ficha: visor de fotos (tocar la foto lo abre; deslizar; tocar o pellizcar para ampliar) ---------- */
  (function () {
    var caja = $('#jl-zoom'); if (!caja) return;
    var pista = $('[data-jl-zoom-pista]', caja), sls = $$('.jl-zoom__sl', caja), puntosC = $('.jl-zoom__puntos', caja);
    var puntos = sls.map(function () { var s = document.createElement('span'); puntosC.appendChild(s); return s; });
    if (sls.length < 2) caja.classList.add('is-una');
    var z = { img: null, s: 1, x: 0, y: 0 };
    var poner = function () {
      if (z.img) z.img.style.transform = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.s + ')';
      caja.classList.toggle('is-zoom', z.s > 1);
    };
    var quitarZoom = function () { if (z.img) { z.img.style.transition = 'transform .2s'; z.s = 1; z.x = 0; z.y = 0; poner(); } };
    var actual = function () { return Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth)); };
    var marcar = function () { var i = actual(); puntos.forEach(function (p, k) { p.classList.toggle('is-act', k === i); }); };
    var ir = function (i, suave) {
      i = Math.max(0, Math.min(sls.length - 1, i));
      quitarZoom();
      pista.scrollTo({ left: i * pista.clientWidth, behavior: suave ? 'smooth' : 'auto' });
    };
    var abrir = function (i) {
      sls.forEach(function (s) { var im = s.querySelector('img'); if (!im.getAttribute('src')) im.src = im.getAttribute('data-src'); });
      caja.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      void pista.offsetWidth; ir(i, false); marcar();
      $('.jl-zoom__cerrar', caja).focus({ preventScroll: true });
      /* 28 oct: la foto grande cuenta como un paso del historial, así el «atrás» del móvil la cierra y se queda en la ficha */
      if (!(history.state && history.state.jlZoom)) history.pushState({ jlZoom: 1 }, '');
    };
    var cerrarVisor = function () {
      if (caja.hidden) return;
      quitarZoom();
      caja.hidden = true;
      document.documentElement.style.overflow = '';
    };
    window.jlVisorCerrar = function () {
      if (caja.hidden) return;
      if (history.state && history.state.jlZoom) { history.back(); return; }
      cerrarVisor();
    };
    window.addEventListener('popstate', cerrarVisor);
    pista.addEventListener('scroll', marcar, { passive: true });
    document.addEventListener('click', function (e) {
      var g = e.target.closest('[data-jl-zoom]');
      if (g && !e.target.closest('button, a, video, iframe')) { abrir(parseInt(g.getAttribute('data-jl-zoom'), 10) || 0); return; }
      if (e.target.closest('[data-jl-zoom-cerrar]')) { window.jlVisorCerrar(); return; }
      var p = e.target.closest('[data-jl-zoom-paso]');
      if (p) ir(actual() + parseInt(p.getAttribute('data-jl-zoom-paso'), 10), true);
    });
    document.addEventListener('keydown', function (e) {
      var g = e.target.closest && e.target.closest('[data-jl-zoom]');
      if (g && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); abrir(parseInt(g.getAttribute('data-jl-zoom'), 10) || 0); return; }
      if (caja.hidden) return;
      if (e.key === 'ArrowRight') ir(actual() + 1, true);
      if (e.key === 'ArrowLeft') ir(actual() - 1, true);
    });
    // Un toque amplía en ese punto (otro toque vuelve); arrastrar mueve la foto ampliada; dos dedos, pellizco.
    var dedos = {}, ini = null;
    var lista = function () { return Object.keys(dedos).map(function (k) { return dedos[k]; }); };
    var dist = function (a, b) { return Math.hypot(a.x - b.x, a.y - b.y); };
    var limitar = function (im) {
      var lx = Math.max(0, (im.offsetWidth * z.s - im.offsetWidth) / 2), ly = Math.max(0, (im.offsetHeight * z.s - im.offsetHeight) / 2);
      z.x = Math.max(-lx, Math.min(lx, z.x)); z.y = Math.max(-ly, Math.min(ly, z.y));
    };
    sls.forEach(function (s) {
      var im = s.querySelector('img');
      im.addEventListener('pointerdown', function (e) {
        if (z.img !== im) { quitarZoom(); z.img = im; }
        im.style.transition = 'none';
        dedos[e.pointerId] = { x: e.clientX, y: e.clientY };
        var l = lista();
        ini = { s: z.s, x: z.x, y: z.y, px: e.clientX, py: e.clientY, t: Date.now(), mov: false, d: l.length === 2 ? dist(l[0], l[1]) : 0 };
        if (z.s > 1 || l.length === 2) { try { im.setPointerCapture(e.pointerId); } catch (err) {} }
      });
      im.addEventListener('pointermove', function (e) {
        if (!dedos[e.pointerId] || !ini) return;
        dedos[e.pointerId] = { x: e.clientX, y: e.clientY };
        var l = lista();
        if (l.length === 2 && ini.d) {
          z.s = Math.max(1, Math.min(4, ini.s * dist(l[0], l[1]) / ini.d));
          if (z.s === 1) { z.x = 0; z.y = 0; }
          ini.mov = true; limitar(im); poner(); return;
        }
        if (z.s > 1) {
          var dx = e.clientX - ini.px, dy = e.clientY - ini.py;
          if (Math.abs(dx) + Math.abs(dy) > 4) ini.mov = true;
          z.x = ini.x + dx; z.y = ini.y + dy; limitar(im); poner();
        } else if (Math.abs(e.clientX - ini.px) > 6) ini.mov = true;
      });
      var fin = function (e) {
        if (!dedos[e.pointerId]) return;
        delete dedos[e.pointerId];
        if (!ini) return;
        if (e.type === 'pointerup' && !ini.mov && lista().length === 0 && Date.now() - ini.t < 400) {
          im.style.transition = 'transform .2s';
          if (z.s > 1) { z.s = 1; z.x = 0; z.y = 0; }
          else {
            var r = im.getBoundingClientRect();
            z.s = 2.5; z.x = (r.left + r.width / 2 - e.clientX) * 1.5; z.y = (r.top + r.height / 2 - e.clientY) * 1.5;
            limitar(im);
          }
          poner();
        }
        if (lista().length === 0) ini = null;
      };
      im.addEventListener('pointerup', fin);
      im.addEventListener('pointercancel', fin);
    });
  })();
  /* ---------- Ficha: «¿Qué es?» plegado con «Leer más» (solo si el texto es largo) ---------- */
  $$('[data-jl-plegable]').forEach(function (bloque) {
    var b = bloque.parentNode.querySelector('[data-jl-leer]');
    if (!b) return;
    if (bloque.scrollHeight > bloque.clientHeight + 24) { b.hidden = false; } else { bloque.classList.add('is-open'); }
    b.addEventListener('click', function () {
      var abierto = bloque.classList.toggle('is-open');
      b.textContent = abierto ? (b.getAttribute('data-menos') || 'Leer menos') : (b.getAttribute('data-mas') || 'Leer más');
      b.setAttribute('aria-expanded', abierto);
    });
  });
  /* 28 oct · enlaces dentro de un panel abierto: sustituyen el paso del panel en el historial.
     3 nov (Cristian): en menú, favoritos, cesta y buscador el paso se queda con lo que había abierto (panel, acordeones,
     desplazamiento, texto buscado) y «atrás» desde la página nueva vuelve a abrirlo así. Los filtros siguen sustituyendo. */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var s = history.state;
    if (!(s && s.jlPanel)) return;
    var a = e.target.closest('a[href]');
    if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
    if (!a.closest('#jl-menu, #jl-cajon, #jl-favs, #jl-fil, #jl-bus')) return;
    var u = new URL(a.href, location.href);
    if (u.origin !== location.origin || (u.pathname === location.pathname && u.search === location.search && u.hash)) return;
    if (atrasVolver[s.jlPanel]) {
      history.replaceState({ jlPanel: s.jlPanel, jlVolver: atrasVolver[s.jlPanel].datos() }, '');
      return;   // el enlace navega normal: la página nueva es un paso más
    }
    e.preventDefault();
    location.replace(u.href);
  });
  /* 3 nov · al volver con «atrás» a un paso que guardó un panel, se reabre como estaba */
  function atrasReabrir() {
    var s = history.state;
    if (s && s.jlVolver && atrasVolver[s.jlPanel]) atrasVolver[s.jlPanel].abrir(s.jlVolver);
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) atrasReabrir(); });   // la primera vez, al final del fichero
  /* ---------- 28 oct · Buscador instantáneo (interruptor jl_p_buscador) ----------
     La lupa abre #jl-bus sin cambiar de página. Desde la 2.ª letra pide a Shopify (/search/suggest.json, sin apps)
     hasta 6 juguetes y las categorías que coinciden. Se cierra con «Cerrar», Escape o el «atrás» del móvil. */
  (function () {
    var bus = $('#jl-bus');
    if (!bus) return;
    var q = $('[data-jl-bus-q]', bus), form = $('.jl-bus__barra', bus), res = $('[data-jl-bus-res]', bus),
        inicio = $('[data-jl-bus-inicio]', bus), borrar = $('[data-jl-bus-borrar]', bus);
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var CLAVE = 'jl-busquedas', cache = {}, pedido = null, temp = null, ultima = '';
    function leer() { try { return JSON.parse(localStorage.getItem(CLAVE)) || []; } catch (e) { return []; } }
    function guardar(l) { try { localStorage.setItem(CLAVE, JSON.stringify(l)); } catch (e) {} }
    function anotar(s) {
      s = String(s || '').trim(); if (s.length < 2) return;
      var l = leer().filter(function (x) { return x.toLowerCase() !== s.toLowerCase(); });
      l.unshift(s); guardar(l.slice(0, 6));
    }
    function urlBuscar(s) { return raiz + 'search?q=' + encodeURIComponent(s) + '&type=product&options%5Bprefix%5D=last'; }
    function pintarUltimas() {
      var l = leer(), caja = $('[data-jl-bus-ultimas]', bus);
      if (!caja) return;
      $('[data-jl-bus-ultimas-lista]', bus).innerHTML = l.map(function (s) {
        return '<a href="' + urlBuscar(s) + '" data-jl-bus-termino="' + esc(s) + '">' + esc(s) + '</a>';
      }).join('');
      caja.hidden = !l.length;
    }
    function euros(v) {
      var n = Number(v); if (!isFinite(n)) return '';
      return n.toFixed(2).replace('.', ',') + ' €';
    }
    // pone en negrita lo escrito dentro del nombre (sin distinguir mayúsculas ni tildes)
    function sinTildes(s) { return s.normalize ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : s; }
    function resaltar(texto, s) {
      var a = sinTildes(texto.toLowerCase()), b = sinTildes(s.toLowerCase().trim()), i = b ? a.indexOf(b) : -1;
      if (i < 0 || a.length !== texto.length) return esc(texto);
      return esc(texto.slice(0, i)) + '<mark>' + esc(texto.slice(i, i + b.length)) + '</mark>' + esc(texto.slice(i + b.length));
    }
    function img(u) {
      if (!u) return '';
      return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=160';
    }
    function pintar(s, r) {
      var prods = (r && r.products) || [], cols = (r && r.collections) || [], h = '';
      if (prods.length) {
        h += '<p class="jl-bus__h">Juguetes</p><div class="jl-bus__lista">';
        prods.forEach(function (p) {
          var rebaja = Number(p.compare_at_price_max) > Number(p.price);
          h += '<a class="jl-bus__fila" href="' + esc(p.url) + '">' +
            '<span class="jl-bus__img">' + (p.image ? '<img src="' + esc(img(p.image)) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</span>' +
            '<span class="jl-bus__info">' + (p.vendor ? '<small>' + esc(p.vendor) + '</small>' : '') +
            '<strong>' + resaltar(p.title || '', s) + '</strong>' +
            (p.available === false ? '<em>Agotado</em>' : '') + '</span>' +
            '<b class="jl-bus__precio">' + euros(p.price) + (rebaja ? '<s>' + euros(p.compare_at_price_max) + '</s>' : '') + '</b></a>';
        });
        h += '</div>';
      }
      if (cols.length) {
        h += '<p class="jl-bus__h">Categorías y marcas</p><div class="jl-sug__chips">' + cols.map(function (c) {
          return '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
        }).join('') + '</div>';
      }
      if (prods.length) {
        h += '<a class="jl-btn jl-bus__todos" href="' + urlBuscar(s) + '" data-jl-bus-termino="' + esc(s) + '">Ver todos los resultados</a>';
      } else if (!cols.length) {
        var wa = bus.getAttribute('data-wa');
        h += '<div class="jl-bus__nada"><p><strong>No encontramos «' + esc(s) + '».</strong> Prueba con otra palabra o con la marca. ' +
          (wa ? 'Si no lo ves, escríbenos y te ayudamos a encontrarlo.' : '') + '</p>' +
          (wa ? '<a class="jl-btn" href="' + esc(wa) + '" target="_blank" rel="noopener">Escríbenos por WhatsApp</a>' : '') + '</div>';
      }
      res.innerHTML = h;
      res.hidden = false; inicio.hidden = true;
    }
    function buscar() {
      var s = q.value.trim();
      borrar.hidden = !q.value;
      if (s.length < 2) { ultima = ''; res.hidden = true; res.innerHTML = ''; inicio.hidden = false; pintarUltimas(); return; }
      if (s === ultima) return;
      ultima = s;
      if (cache[s]) { pintar(s, cache[s]); return; }
      if (pedido) pedido.abort();
      pedido = window.AbortController ? new AbortController() : null;
      bus.classList.add('is-cargando');
      fetch(raiz + 'search/suggest.json?q=' + encodeURIComponent(s) +
        '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last', pedido ? { signal: pedido.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var r = (d && d.resources && d.resources.results) || {};
          cache[s] = r;
          if (q.value.trim() === s) pintar(s, r);
        })
        .catch(function () {})
        .then(function () { bus.classList.remove('is-cargando'); });
    }
    function abrir() {
      if (menu && !menu.hidden) cerrarMenuYa();
      if (favPanel && !favPanel.hidden) favCerrarYa();
      bus.hidden = false; html.classList.add('jl-noscroll');
      pintarUltimas();
      q.focus();   // en el mismo toque, para que el móvil saque el teclado
      atrasPoner('buscar');
    }
    function cerrarYa() {
      if (bus.hidden) return;
      bus.hidden = true; html.classList.remove('jl-noscroll');
      q.blur();
    }
    function cerrar() {
      if (bus.hidden) return;
      if (atrasQuitar('buscar')) return;
      cerrarYa();
    }
    atrasCierres.buscar = cerrarYa;
    atrasVolver.buscar = {
      datos: function () { return { q: q.value }; },
      abrir: function (d) {
        if (bus.hidden) abrir();
        q.value = d.q || ''; ultima = ''; buscar();
        q.blur();   // al volver, sin sacar el teclado
      }
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest('.jl-cab__buscar, .jl-cab__buscar-esc')) { e.preventDefault(); abrir(); return; }
      if (bus.hidden) return;
      if (e.target.closest('[data-jl-bus-cerrar]')) { e.preventDefault(); cerrar(); return; }
      if (e.target.closest('[data-jl-bus-borrar]')) { e.preventDefault(); q.value = ''; buscar(); q.focus(); return; }
      if (e.target.closest('[data-jl-bus-olvidar]')) { e.preventDefault(); guardar([]); pintarUltimas(); q.focus(); return; }
      var t = e.target.closest('[data-jl-bus-termino]');
      if (t) anotar(t.getAttribute('data-jl-bus-termino'));
      else if (e.target.closest('.jl-bus__fila')) anotar(q.value);
    });
    q.addEventListener('input', function () { clearTimeout(temp); temp = setTimeout(buscar, 180); });
    form.addEventListener('submit', function (e) {
      var s = q.value.trim();
      e.preventDefault();
      if (s.length < 1) return;
      anotar(s);
      location.replace(urlBuscar(s));   // como los enlaces del panel: luego un solo «atrás»
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !bus.hidden) cerrar(); });
    // al volver con «atrás» desde un resultado, el panel no se queda abierto
    window.addEventListener('pageshow', function (e) { if (e.persisted && !(history.state && history.state.jlVolver)) cerrarYa(); });
  })();
  /* ---------- 30 oct · Flechas en los carruseles, solo en ordenador (las pinta el CSS desde 990 px) ---------- */
  (function () {
    var FL = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
    $$('.jl-carrusel').forEach(function (fila) {
      var caja = fila.parentNode;
      caja.classList.add('jl-carr');
      function boton(clase, etiqueta, signo) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'jl-carr-fl ' + clase; b.setAttribute('aria-label', etiqueta);
        b.innerHTML = signo > 0 ? FL.replace('M15 6l-6 6 6 6', 'M9 6l6 6-6 6') : FL;
        b.addEventListener('click', function () {
          var hijos = Array.prototype.slice.call(fila.children), paso = jlPasoCarrusel(fila, hijos);
          var w = hijos.length ? hijos[0].getBoundingClientRect().width : fila.clientWidth, gap = parseFloat(getComputedStyle(fila).columnGap) || 0;
          fila.scrollBy({ left: signo * paso * (w + gap), behavior: 'smooth' });
        });
        caja.appendChild(b);
        return b;
      }
      var ant = boton('jl-carr-fl--ant', 'Ver anteriores', -1), sig = boton('jl-carr-fl--sig', 'Ver más', 1);
      function estado() {
        var max = fila.scrollWidth - fila.clientWidth;
        ant.hidden = fila.scrollLeft < 8;
        sig.hidden = fila.scrollLeft > max - 8;
      }
      fila.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado);
      window.addEventListener('load', estado);
      estado();
    });
  })();
  atrasReabrir();   // 3 nov: con todos los paneles ya registrados
})();

